import React from 'react';
import { Film, Youtube, ExternalLink } from 'lucide-react';

const EcosystemCard = ({ icon: Icon, title, description, url }) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="group block p-8 bg-[#121917] border border-[#52ea88]/10 hover:border-[#52ea88]/40 transition-all duration-400"
    >
      {/* Subtle hover glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#52ea88]/3 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400 pointer-events-none" />
      
      <div className="relative z-10 space-y-4">
        {/* Icon */}
        <div className="w-14 h-14 border border-[#52ea88]/20 flex items-center justify-center group-hover:border-[#52ea88]/50 transition-colors">
          <Icon className="w-6 h-6 text-[#52ea88]" />
        </div>

        {/* Title with external link indicator */}
        <div className="flex items-center gap-2">
          <h3 className="text-xl font-semibold text-[#E6FFF6] group-hover:text-[#52ea88] transition-colors">
            {title}
          </h3>
          <ExternalLink className="w-4 h-4 text-[#9FBFB4] opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>

        {/* Description */}
        <p className="text-[#9FBFB4] text-sm leading-relaxed">
          {description}
        </p>

        {/* Decorative Line */}
        <div className="w-8 h-0.5 bg-[#9FBFB4]/20 group-hover:bg-[#52ea88] group-hover:w-12 transition-all duration-400" />
      </div>
    </a>
  );
};

const Ecosystem = () => {
  const ecosystemLinks = [
    {
      icon: Film,
      title: 'The Movie Matrix Trailers',
      description: 'Explore curated movie trailers across genres and eras.',
      url: 'https://moviematrixtrailers.com/',
    },
    {
      icon: Youtube,
      title: 'The Movie Matrix TV',
      description: 'Watch recommendations, lists, and cinematic deep dives on YouTube.',
      url: 'https://www.youtube.com/@TheMovieMatrixTV',
    },
  ];

  return (
    <section className="bg-[#0B0F0E] py-24 border-t border-[#52ea88]/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="space-y-2 mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-semibold text-[#E6FFF6]">
            The Movie Matrix Ecosystem
          </h2>
          <p className="text-[#9FBFB4] text-lg max-w-2xl mx-auto">
            Discover more cinematic content across our platforms.
          </p>
          <div className="w-20 h-1 bg-[#52ea88] mx-auto mt-4"></div>
        </div>

        {/* Ecosystem Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {ecosystemLinks.map((link) => (
            <EcosystemCard
              key={link.title}
              icon={link.icon}
              title={link.title}
              description={link.description}
              url={link.url}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;
